<template>
  <div>
    <div class="d-inline overline">
      New

    </div>
    <div
      v-for="(i) in [1,2,3,4,5]"
      :key="i"
      class="d-inline pointer"
      @click="setRating(i)"
      >
      <v-icon color="blue lighten-2" v-if="rating >= i">mdi-checkbox-blank-circle</v-icon>
      <v-icon color="grey lighten-1"  v-if="rating < i">mdi-checkbox-blank-circle-outline</v-icon>
    </div>
    <div class="d-inline overline">
      Know

    </div>

  </div>

</template>
<script>
export default {
  name: 'Rating',
  data: () => {
    return {
      rating: 0,

    }
  },
  methods: {
    setRating(val) {
      this.rating = val
      this.$emit('ratingSet', this.rating)
    }

  }
}
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
</style>
